const extractNumberFromString = (input: string): number | null => {
  const match = input.match(/-?\d+(\.\d+)?/);
  return match ? parseFloat(match[0]) : null;
}

export default extractNumberFromString;
